import React, { useState } from 'react';

const faqs = [
  {
    q: '¿Necesito conocimientos técnicos para usar MetalRecovery?',
    a: 'No. La plataforma está diseñada para recuperadores de metales, no para analistas financieros. Introduces el metal, el peso y el yield — MetalRecovery hace todos los cálculos automáticamente y te da el precio máximo que deberías pagar en ese momento.',
  },
  {
    q: '¿Cómo calcula el precio máximo de compra?',
    a: 'El sistema combina el benchmark LME en tiempo real (convertido a EUR usando el tipo de cambio del día), el yield de tu categoría, tus costes operativos, tu margen objetivo y un buffer de riesgo basado en la volatilidad histórica del metal. El resultado es el precio más alto que puedes pagar garantizando tu rentabilidad.',
  },
  {
    q: '¿Qué pasa si en la negociación decido pagar más del precio máximo calculado?',
    a: 'Puedes introducir el precio negociado y el sistema calcula al instante el riesgo asumido, el margen real resultante y el punto de equilibrio del lote. Así tomas la decisión con información completa, no a ciegas.',
  },
  {
    q: '¿De dónde vienen los precios LME?',
    a: 'La herramienta cuenta con una conexión directa al mercado, lo que le permite recibir y actualizar los precios del LME en tiempo real, garantizando que los cálculos se basen siempre en las fluctuaciones del mercado actual.',
  },
  {
    q: '¿Funciona para todos los metales?',
    a: 'Sí. MetalRecovery cubre metales LME cotizados (cobre, aluminio, zinc, plomo, níquel, estaño), metales con índice regional (acero inoxidable, hierro, latón) y precios manuales para cualquier otro material.',
  },
  {
    q: '¿Hay un período de prueba?',
    a: 'Puedes acceder a la demo gratuita con datos precargados sin necesidad de tarjeta de crédito. Explora todas las funcionalidades antes de decidir.',
  },
];

function FAQItem({ item, isOpen, onToggle }) {
  return (
    <div
      style={{
        borderBottom: '1px solid #e2e8f0',
        overflow: 'hidden',
      }}
    >
      <button
        onClick={onToggle}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 16,
          padding: '20px 0',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          textAlign: 'left',
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          minHeight: 64,
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        <span
          style={{
            fontSize: '1rem',
            fontWeight: 600,
            color: '#0f172a',
            lineHeight: 1.4,
            flex: 1,
          }}
        >
          {item?.q}
        </span>
        <span
          style={{
            flexShrink: 0,
            width: 32,
            height: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            background: isOpen ? '#EA580C' : '#fff7ed',
            transition: 'background 0.2s',
          }}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            style={{
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.25s ease',
            }}
          >
            <path
              d="M2 5l5 5 5-5"
              stroke={isOpen ? '#ffffff' : '#EA580C'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>
      <div
        style={{
          maxHeight: isOpen ? 400 : 0,
          overflow: 'hidden',
          transition: 'max-height 0.3s ease',
        }}
      >
        <p
          style={{
            fontSize: '0.9375rem',
            color: '#475569',
            lineHeight: 1.7,
            paddingBottom: 20,
            margin: 0,
          }}
        >
          {item?.a}
        </p>
      </div>
    </div>
  );
}

export default function LandingFAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section
      style={{
        background: '#ffffff',
        padding: '96px 24px',
        fontFamily: "'Plus Jakarta Sans', sans-serif",
      }}
      className="faq-section"
    >
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <h2
          style={{
            fontSize: 'clamp(1.6rem, 3vw, 2rem)',
            fontWeight: 800,
            color: '#0f172a',
            letterSpacing: '-0.02em',
            textAlign: 'center',
            marginBottom: 56,
          }}
        >
          Preguntas frecuentes
        </h2>
        <div>
          {faqs?.map((item, idx) => (
            <FAQItem
              key={idx}
              item={item}
              isOpen={openIndex === idx}
              onToggle={() => handleToggle(idx)}
            />
          ))}
        </div>
      </div>
      <style>{`
        @media (max-width: 480px) {
          .faq-section {
            padding: 64px 16px !important;
          }
        }
      `}</style>
    </section>
  );
}
